/**
 * Dependencies
 */
import http from '../../../services/HttpService'

const fetchAll = ({ commit }) => {
    commit('SET_LOADING')
    http.get(`comps/dashboard/`)
        .then(res => {
            commit('SET_DATA', {
                data: res.data,
                type: 'all'
            })
            commit('RESET_LOADING')
        })
        .catch(() => commit('RESET_LOADING'))
}

/**
 * Get the available comps for a given type
 *
 * @param  {Function} options.commit
 * @param  {String} type
 * @return {Void}
 */
const fetchByType = ({ commit }, type) => {
    commit('SET_LOADING')
    http.get(`comps/dashboard/${type}/`)
        .then(res => {
            commit('SET_DATA', {
                data: res.data,
                type: type
            })
            commit('RESET_LOADING')
        })
        .catch(() => commit('RESET_LOADING'))
}

export default {
    fetchAll,
    fetchByType
}



// WEBPACK FOOTER //
// ./src/state/modules/comps/actions.js